import React from "react";
import { Link } from "react-router-dom";
import styles from "./Wholesale.module.css";
import NewPolaroid from "../../Components/Products/NewPolaroid";

function Wholesale() {
  return (
    <div className={styles.Wholesale}>
      <h1 className={styles.WholesaleTitle}>Wholesale</h1>
      <div className={styles.Overview}>
        <p>
          We are delighted that you are interested in offering our products to
          your customers.
        </p>
        <p>
          Whether you’re a shop, boutique, hotel, or other establishment looking
          to stock our embroidered gifts, please browse our{" "}
          <Link className={styles.CataglogueLink} to="/wholesale/Products">wholesale catalogue here.</Link> We can
          work with you to tailor the designs and colour options to your shop,
          brand, and customer interests. You can order individual products or
          request ready-made hampers.
        </p>
        <p><a className={styles.Email} href="mailto:contact@matchhampers.com">Email us</a> to discuss your wholesale order today.</p>
        <p>
          We thank you for considering us as your wholesale partner. We look
          forward to working with you!
        </p>
      </div>
      <div className={styles.WholesaleProducts}>
        <NewPolaroid
          Title="Wholesale Products"
          Route="Wholesale"
          Images={new Array("/Images/Wholesale/WholesaleProducts.jpg")}
          hidePrice={true}
          FriendlyName="Products"
          Name="View Wholesale Products"
        />
      </div>
    </div>
  );
}

export default Wholesale;
